import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AuthGuard } from './auth/AuthGuard.js';
import { Layout } from './components/Layout.js';
import { Dashboard } from './pages/Dashboard.js';
import { TenantDetail } from './pages/TenantDetail.js';
import { TenantNew } from './pages/TenantNew.js';
import { TenantEdit } from './pages/TenantEdit.js';
import { FlowList } from './pages/FlowList.js';
import { FlowEditor } from './pages/FlowEditor.js';
import { WidgetPreview } from './pages/WidgetPreview.js';
import { ChannelsList } from './pages/ChannelsList.js';
import { ContactsList } from './pages/ContactsList.js';
import { ChannelForm } from './pages/ChannelForm.js';
import { ConnectorsList } from './pages/ConnectorsList.js';
import { ConnectorForm } from './pages/ConnectorForm.js';
import { CcConnectorsList } from './pages/CcConnectorsList.js';
import { TenantDashboard } from './pages/TenantDashboard.js';
import { TemplatesList } from './pages/TemplatesList.js';
import { WhatsAppFlowsList } from './pages/WhatsAppFlowsList.js';
import { WaMediaUpload } from './pages/WaMediaUpload.js';
import { TemplateForm } from './pages/TemplateForm.js';
import { CampaignsList } from './pages/CampaignsList.js';
import { CampaignForm } from './pages/CampaignForm.js';
import { CampaignDetail } from './pages/CampaignDetail.js';
import { SurveysList } from './pages/SurveysList.js';
import { SurveyForm } from './pages/SurveyForm.js';
import { WidgetsList } from './pages/WidgetsList.js';
import { WidgetForm } from './pages/WidgetForm.js';
import { UsersList } from './pages/UsersList.js';
import { UserForm } from './pages/UserForm.js';
import { ApiKeysList } from './pages/ApiKeysList.js';
import { VariablesList } from './pages/VariablesList.js';
import { NotFound } from './pages/NotFound.js';
import { LoginPage } from './pages/Login.js';
import { CallbackPage } from './pages/Callback.js';

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  { path: '/callback', element: <CallbackPage /> },
  {
    path: '/',
    element: (
      <AuthGuard>
        <Layout />
      </AuthGuard>
    ),
    children: [
      { index: true, element: <Dashboard /> },
      // El listado de tenants vive en `/` (Dashboard). Esta route preserva
      // links viejos pero no se referencia desde el Sidebar.
      { path: 'tenants', element: <Navigate to="/" replace /> },
      { path: 'tenants/new', element: <TenantNew /> },
      { path: 'tenants/:id', element: <TenantDetail /> },
      { path: 'tenants/:id/edit', element: <TenantEdit /> },
      { path: 'tenants/:id/channels', element: <ChannelsList /> },
      { path: 'tenants/:id/contacts', element: <ContactsList /> },
      { path: 'tenants/:id/channels/new', element: <ChannelForm mode="create" /> },
      { path: 'tenants/:id/channels/:channelId/edit', element: <ChannelForm mode="edit" /> },
      { path: 'tenants/:id/connectors', element: <ConnectorsList /> },
      { path: 'tenants/:id/connectors/new', element: <ConnectorForm mode="create" /> },
      { path: 'tenants/:id/connectors/:connectorId/edit', element: <ConnectorForm mode="edit" /> },
      { path: 'tenants/:id/cc-connectors', element: <CcConnectorsList /> },
      { path: 'tenants/:id/dashboard', element: <TenantDashboard /> },
      { path: 'tenants/:id/templates', element: <TemplatesList /> },
      { path: 'tenants/:id/wa-flows', element: <WhatsAppFlowsList /> },
      { path: 'tenants/:id/wa-media', element: <WaMediaUpload /> },
      { path: 'tenants/:id/templates/new', element: <TemplateForm mode="create" /> },
      { path: 'tenants/:id/templates/:templateId/edit', element: <TemplateForm mode="edit" /> },
      { path: 'tenants/:id/campaigns', element: <CampaignsList /> },
      { path: 'tenants/:id/campaigns/new', element: <CampaignForm mode="create" /> },
      { path: 'tenants/:id/campaigns/:campaignId', element: <CampaignDetail /> },
      { path: 'tenants/:id/campaigns/:campaignId/edit', element: <CampaignForm mode="edit" /> },
      { path: 'tenants/:id/surveys', element: <SurveysList /> },
      { path: 'tenants/:id/surveys/new', element: <SurveyForm mode="create" /> },
      { path: 'tenants/:id/surveys/:surveyId/edit', element: <SurveyForm mode="edit" /> },
      { path: 'tenants/:id/widgets', element: <WidgetsList /> },
      { path: 'tenants/:id/widgets/new', element: <WidgetForm mode="create" /> },
      { path: 'tenants/:id/widgets/:widgetId/edit', element: <WidgetForm mode="edit" /> },
      { path: 'tenants/:id/users', element: <UsersList /> },
      { path: 'tenants/:id/users/new', element: <UserForm mode="create" /> },
      { path: 'tenants/:id/users/:username/edit', element: <UserForm mode="edit" /> },
      { path: 'tenants/:id/api-keys', element: <ApiKeysList /> },
      { path: 'tenants/:id/variables', element: <VariablesList /> },
      { path: 'tenants/:id/flows', element: <FlowList /> },
      { path: 'tenants/:id/flows/:flowId', element: <FlowEditor /> },
      { path: 'tenants/:id/widget', element: <WidgetPreview /> },
      { path: '*', element: <NotFound /> },
    ],
  },
]);
